/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Overwrite_TitleInputs */



/**
* | output |
* | --- |
* | "Overwrite Project" |
*
* @param {Explorer_Table_Overwrite_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_overwrite_title = /** @type {((inputs?: Explorer_Table_Overwrite_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Overwrite_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ecraser le projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt überschreiben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sovrascrivi progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перезаписать проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sobrescribir proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("覆盖项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトを上書き")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट को ओवरराइट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto de Sobrescrita")
	return /** @type {LocalizedString} */ ("Overwrite Project")
});